import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import './Ourwork2.css';

import back1 from '../Imges/OurWorks/Our-1.jpg';
import back2 from '../Imges/OurWorks/Our-2.jpg';
import back3 from '../Imges/OurWorks/Our-3.jpg';
import back4 from '../Imges/OurWorks/Our-4.jpg';
import back5 from '../Imges/OurWorks/Our-5.jpg';
import back6 from '../Imges/OurWorks/Our-6.jpg';
import back7 from '../Imges/OurWorks/Our-7.jpg';
import back8 from '../Imges/OurWorks/Our-8.jpg';
import back9 from '../Imges/OurWorks/Our-9.jpg';
import back10 from '../Imges/OurWorks/Our-10.jpg';
import back11 from '../Imges/OurWorks/Our-11.jpg';
import back12 from '../Imges/OurWorks/Our-12.jpg';
import logo2 from '../Imges/logo.png';

const categories = ['all', 'advt', 'broadsheet', 'hoarding', 'leaflet', 'tabloid'];

const imagesData = [
  { src: back1, alt: 'Advt', category: 'hoarding' },
  { src: back2, alt: 'Advt', category: 'tabloid' },
  { src: back3, alt: 'Advt', category: 'tabloid' },
  { src: back4, alt: 'Advt', category: 'advt' },
  { src: back5, alt: 'Advt', category: 'advt' },
  { src: back6, alt: 'Advt', category: 'leaflet' },
  { src: back7, alt: 'Advt', category: 'leaflet' },
  { src: back8, alt: 'Advt', category: 'hoarding' },
  { src: back9, alt: 'Advt', category: 'tabloid' },
  { src: back10, alt: 'Advt', category: 'all' },
  { src: back11, alt: 'Advt', category: 'tabloid' },
  { src: back12, alt: 'Advt', category: 'broadsheet' },
  { src: back7, alt: 'Advt', category: 'broadsheet' },
];

const Works = () => {
  const [activeCategory, setActiveCategory] = useState('all');
  const [selectedImage, setSelectedImage] = useState(null);

  const filteredImages = (() => {
    if (activeCategory === 'all') {
      return imagesData;
    } else if (['advt', 'broadsheet', 'hoarding', 'leaflet'].includes(activeCategory)) {
      return imagesData.filter(img => img.category === activeCategory).slice(0, 2);
    } else if (activeCategory === 'tabloid') {
      return imagesData.filter(img => img.category === activeCategory).slice(0, 4);
    } else {
      return [];
    }
  })();

  return (
    <div className="meet-our-clients">
      <Header />
      <NavBar activeCategory={activeCategory} setActiveCategory={setActiveCategory} />
      
      <motion.div
        key={activeCategory}
        initial={{ opacity: 0, scale: 0.8 }}
        animate={{ opacity: 1, scale: 1 }}
        exit={{ opacity: 0, scale: 0.8 }}
        transition={{ duration: 0.5 }}
      >
        <Gallery images={filteredImages} onImageClick={setSelectedImage} />
      </motion.div>

      <AnimatePresence>
        {selectedImage && (
          <motion.div
            className="modal"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            onClick={() => setSelectedImage(null)}
          >
            <div onClick={(e) => e.stopPropagation()} style={{ position: 'relative' }}>
              <motion.img
                src={selectedImage.src}
                alt={selectedImage.alt}
                initial={{ y: "-100vh" }}
                animate={{ y: 0 }}
                exit={{ y: "100vh" }}
                className="modal-image"
              />
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
};

const Header = () => (
  <header>
    <h1><img src={logo2} alt="Divyam Ads Logo" className="logo2" /></h1>
  </header>
);

const NavBar = ({ activeCategory, setActiveCategory }) => (
  <nav>
    {categories.map(category => (
      <button
        key={category}
        className={`filter-btn ${activeCategory === category ? 'active' : ''}`}
        onClick={() => setActiveCategory(category)}
      >
        {category.toUpperCase()}
      </button>
    ))}
  </nav>
);

const Gallery = ({ images, onImageClick }) => (
  <motion.section className="gallery">
    {images.length > 0 ? (
      images.map((image, index) => (
        <motion.div
          className={`image ${image.category}`}
          key={index}
          initial={{ opacity: 0, y: 50 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5, delay: index * 0.1 }}
          onClick={() => onImageClick(image)}
        >
          <img src={image.src} alt={image.alt} />
        </motion.div>
      ))
    ) : (
      <p>No images available</p>
    )}
  </motion.section>
);

export default Works;
